module.exports = __webpack_public_path__ + "static/media/button_minus_dark.00b15fe3.svg";